import { WidgetInfo, WidgetInfoQuery } from '@dreryk/egabinet-patient-portal-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType, StyledFlex } from '@dreryk/react-components';

import { patientPortalTranslationKeys } from '../../translations';

type WidgetInfoLoaderRendererProps = {
   widgetInfo: WidgetInfo;
};

type WidgetInfoLoaderProps = {
   readonly children: (renderProps: Readonly<WidgetInfoLoaderRendererProps>) => JSX.Element;
};

export const WidgetInfoLoader = (props: WidgetInfoLoaderProps): JSX.Element => {
   const { data: widgetInfo, loading: widgetInfoLoading, error: widgetInfoError } = useCqrsGet<WidgetInfo>(() => {
      return new WidgetInfoQuery();
   });

   if (widgetInfoLoading) {
      return <LoaderSpinner />;
   }

   if (widgetInfoError) {
      return (
         <StyledFlex flex={'0 1 28%'}>
            <div>
               <Message
                  testId={'dataFetchingFaultStatus'}
                  type={MessageType.NEGATIVE}
                  label={patientPortalTranslationKeys.dataFetchingFault}
               />
            </div>
         </StyledFlex>
      );
   }

   return props.children({
      widgetInfo: widgetInfo,
   });
};
